<template>
  <!--桌面端-->
  <div id="desk" ref="desk">

  </div>
</template>

<script>
  import img1 from '@/assets/images/index/main-slider-1-1.png';
  import img2 from '@/assets/images/index/main-slider-1-2.jpg';
  import img7 from '@/assets/images/index/main-slider-1-3.jpg';
  import img3 from '@/assets/images/index/liucheng-dark.png';
  import img4 from '@/assets/images/index/liucheng.png';
  import img5 from '@/assets/images/index/feiyong.png';
  import img6 from '@/assets/images/index/feiyong-dark.png';
  export default {
    name: "desk",
    data(){
      return {
        appName:this.$AppName,
        // images:[img1,img2,img7],
        images:[img1],
        langs:this.$Language,
        value2:115,
        value1:this.$Language=='VN'?2000000:3000,
        coin:this.$coin,
        show:false
      }
    },
    created() {
      var system = {
        win: false,
        mac: false,
        xll: false
      };
      //检测平台
      var p = navigator.platform;
      system.win = p.indexOf("Win") == 0;
      system.mac = p.indexOf("Mac") == 0;
      system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
      if (!system.win || system.mac || system.xll) {
        this.$dialog.alert({
          title: this.$t('message.ts'),
          message: this.$t('message.use_phone'),
          confirmButtonText:this.$t('message.determine')
        });
      }
    },
    computed:{
      min(){
        if(this.langs=='VN'){
          return '2000000'
        }else{
          return '1500';
        }
      },
      max(){
        if(this.langs=='VN'){
          return '20000000'
        }else{
          return '5000';
        }
      },
      step(){
        return this.langs=='VN'?500000:500;
      },
      getTime(){
        let time;
        let date = new Date();
        let year = date.getFullYear();
        let month =date.getMonth()+1;
        let day = date.getDate();
        //date对象的set方法，自动折算
        date.setDate(Number(this.value2)+day);
        year = date.getFullYear();
        month =Number(date.getMonth()+1)<10?'0'+(date.getMonth()+1):date.getMonth()+1;
        day = Number(date.getDate())<10?'0'+date.getDate():date.getDate();
        time=day+"-"+month+"-"+year;
        return time;
      }
    },
    methods:{
      add_comma_toThousands(num) {
        var num = (num || 0).toString();
        var result = '';
        while (num.length > 3) {
          result = '.' + num.slice(-3) + result;
          num = num.slice(0, num.length - 3);
        }
        if (num) { result = num + result; }
        return result;
      },
      login(){

      },
      changeIMG(a){
        if(a=='IMG1'){
          this.$refs.IMG1.setAttribute("src",img3);
        }else{
          this.$refs.IMG2.setAttribute("src",img6);
        }

      },
      changeIMGLeave(a){
        if(a=='IMG1') {
          this.$refs.IMG1.setAttribute("src", img4);
        }else{
          this.$refs.IMG2.setAttribute("src", img5);
        }
      },
      showPopup() {
        this.show = true;
      },
      lxwm(a) {
        switch (a) {
          case 'US':
            this.$router.push('/ContactUS');
            break;
          case 'QS':
            this.$router.push('/problem');
            break;
          default:
            location.reload();
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  #desk{
    #clock{
      color: $index_color;
      margin-right: 5px;
    }
    .container{
      width: 950px;
      margin: 0 auto;
    }
    .header{
      background: #fff;
      height: 2.04rem;
      line-height: 2.04rem;
      .container{
        display: flex;
        align-items: center;
        justify-content: space-between;

        >:nth-child(1){
          width: 35%;
          font-size: 0.56rem;
          color: #0C2139;
        }
        >:nth-child(2){
          width: 65%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          >:nth-child(1){
            >:nth-child(1){
              border-bottom: 3px solid $index_color!important;
            }
            span{
              margin-right: 30px;
              font-size: 0.3rem;
              color: #798497;
              padding-bottom: 6px;
              border-bottom: 3px solid #fff;
            }
            @keyframes example3 {
              0%{
                border-bottom: 3px solid #fff;
              }
              20%{
                border-bottom: 3px solid #f5f9fb;
              }
              100%{
                border-bottom: 3px solid $index_color;
              }
            }
            span:hover{
              cursor: pointer;
              animation: example3 1s linear forwards;
            }
          }
          >:nth-child(2){
            display: flex;
            .van-button{
              height: 0.59rem;
              line-height: 0.59rem;
              margin-left: 0.37rem;
              font-size: 0.3rem;
            }
          }
        }
      }

    }
    #swipe_area{
      position: relative;
      .swipe_text_area{
        position: absolute;
        top:100px;
        left: 0;
        width: 100%;
        .container{
          >:nth-child(1){
            font-size: 0.44rem;
            color:$color;
            margin-bottom: 0.63rem;
          }
          >:nth-child(2){
            font-size: 1.56rem;
            color: #fff;
            margin-bottom: 0.87rem;
            max-width: 13rem;
          }
        }
      }
    }
    /deep/ .van-swipe-item img{
      width: 100%!important;
    }
    .line{
      width: 43px;
      height: 3px;
      background: $index_color;
      display: inline-block;
      vertical-align: middle;
    }
    #loanMoney{
      position: relative;
      top: -2.45rem;
      .container{
        display: flex;
        .loanMoney_left,.loanMoney_right{
          flex: 1;
        }
        .loanMoney_left_top{
          display: flex;
          align-items: center;
          height: 3rem;
          /*line-height: 100px;*/
          box-sizing: border-box;
          font-size: 0.56rem;
          @keyframes example1 {
            from {
              background-color: transparent;
            }
            to {
              background-color: #fff;
              color: #0C2139;
            }
          }
          >:nth-child(1){
            margin-right: 10px;
            /*background: #fff;*/
            padding: 0 15px;
            box-sizing: border-box;
            width: 270px;
            height: 130px;
            /*line-height: 130px;*/
            display: flex;
            align-items: center;
            color: #fff;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
          .bg1:hover,.bg2:hover{
            cursor: pointer;
            color: #0C2139;
            animation: example1 2s linear forwards;

          }

          >:nth-child(2){
            margin-left: 10px;
            /*background: #fff;*/
            padding: 0 15px;
            box-sizing: border-box;
            width: 270px;
            height: 130px;
            /*line-height: 130px;*/
            display: flex;
            align-items: center;
            color: #fff;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
        }
        .loanMoney_left_content{
          >:nth-child(1){
            color: #798490;
            font-size: 0.37rem;
            margin-bottom: 0.5rem;
            margin-top: 35px;
          }
          >:nth-child(2){
            color: #0C2139;
            font-size: 1.11rem;
            max-width: 580px;
            margin-bottom: 0.4rem;
          }
          >:nth-child(3){
            color: #004AA1;
            font-size:0.44rem;
            max-width: 580px;
            margin-bottom:0.5rem;
          }
          >:nth-child(4){
            color: #798490;
            font-size: 0.3rem;
            max-width: 600px;
            line-height: 36px;
          }
        }
        .loanMoney_right{
          margin-left: 80px;
          .loanMoney_right_top{
            height: 2.39rem;
            line-height: 2.39rem;
            /*background: linear-gradient(180deg, #004AA1, #4678B2);*/
            background: $color;
            font-size: 30px;
            color: #fff;
            text-align: center;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            position: relative;
            z-index: 2;
            .triangle{
              width: 100%;
              div{
                margin: 0 auto;
                width: 0px;
                height: 0px;
                border-top: 12px solid $color;
                border-left: 12px solid transparent;
                border-right: 12px solid transparent;
              }
            }
          }
          .loanMoney_right_content{
            padding:30px 60px;
            box-shadow: 0 0 20px rgba(216,216,216,0.7);
            .slide_item{
              margin-bottom:25px;
              .label{
                font-size: 12px;
                color: #88929D;
                margin-bottom: 8px;
              }
              .qj{
                font-size: 14px;
                color: #88929D;
                font-weight: 500;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
            }
            .infos{
              .info_items{
                padding: 0.5rem 0;
                display: flex;
                align-items: center;
                justify-content: space-between;

                >:nth-child(1){
                  color: #88929D;
                  font-size:0.37rem;
                }
                >:nth-child(2){
                  color: #0C2139;
                  font-size: 0.37rem;
                  font-weight: 600;
                }
              }
            }
          }
        }
      }
    }
    #QS{
      margin-top: -20px;
      .head_title{
        text-align: center;
        >:nth-child(1){
          color: #798490;
          font-size: 0.37rem;
          margin-bottom: 0.37rem;
        }
        >:nth-child(2){
          color: #0C2139;
          font-size: 1.11rem;
          margin-bottom: 1rem;
        }
      }
      .QS_content{
        background: #EFF2F6;
        position: relative;
        .container{
          display: flex;
          align-items: center;
          position: relative;
          z-index:2;
          .q3{
            position: absolute;
            bottom: 10px;
            left: -72px;
            z-index:0;
            animation: q2 6s ease-in-out 3s infinite alternate;
          }
          @keyframes q2 {
            0%{
              transform: translateY(0px) translateX(0) rotate(0);
            }
            30% {
              transform: translateY(30px) translateX(50px) rotate(15deg);
              transform-origin: center center;
            }
            50%{
              transform: translateY(50px) translateX(100px) rotate(45deg);
              transform-origin: right bottom;
            }
            80%{
              transform: translateY(30px) translateX(50px) rotate(15deg);
              transform-origin: left top;
            }
            100%{
              transform: translateY(0px) translateX(0) rotate(0);
              transform-origin: center center;
            }
          }
          .QS_content_item{
            flex: 1;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            overflow: hidden;
            position: relative;
            z-index:2;
            .text{
              background: #fff;
              padding:40px ;
              min-height: 4.3rem;
              box-sizing: border-box;
              h4{
                color: #0C2139;
                font-size: 0.44rem;
                font-weight: 600;
                margin-top: 0;
              }
              div{
                color: #798490;
                font-size: 0.33rem;
              }
            }
            img{
              transition: transform 500ms ease, opacity 500ms ease;
              opacity: 1;
              transform: scale(1);
            }
            img:hover{
              cursor: pointer;
              transform: scale(1.05);
              opacity: 0.7;
            }
          }
        }

      }
    }
    #reason{
      padding: 100px 0;
      background: #EFF2F6;
      position: relative;
      .q2{
        position: absolute;
        right: 350px;
        top:80px;
        animation: q2 5s linear infinite;
      }
      @keyframes q2 {
        0%{
          transform: translateY(0px) translateX(0) rotate(0);
        }
        30% {
          transform: translateY(30px) translateX(50px) rotate(15deg);
          transform-origin: center center;
        }
        50%{
          transform: translateY(50px) translateX(100px) rotate(45deg);
          transform-origin: right bottom;
        }
        80%{
          transform: translateY(30px) translateX(50px) rotate(15deg);
          transform-origin: left top;
        }
        100%{
          transform: translateY(0px) translateX(0) rotate(0);
          transform-origin: center center;
        }
      }
      .head_title{
        text-align: center;
        >:nth-child(1){
          color: #798490;
          font-size: 0.37rem;
          margin-bottom: 0.37rem;
        }
        >:nth-child(2){
          color: #0C2139;
          font-size: 1.11rem;
          margin-bottom: 1rem;
        }
      }

      .container{
        display: flex;
        align-items: center;
        position: relative;
        .reason_content_item{
          flex: 1;
          background: #fff;
          border-radius: 5px;
          padding: 34px 40px;
          display: flex;
          align-items: center;
          border-bottom: 3px solid #fff;
          border-top: 3px solid #fff;
          >:nth-child(1){
            margin-right: 15px;
          }
        }
        .reason_content_item:hover{
          box-sizing: border-box;
          cursor: pointer;
          animation: example 2s linear forwards;
        }
        @keyframes example {
          from {border-bottom: 3px solid #fff;}
          to {border-bottom: 3px solid $index_color;}
        }
        .q1{
          position: absolute;
          left: -100px;
          bottom:-84px;
          animation: q1 5s linear infinite;
        }
        @keyframes q1 {
          0%,100% {
            transform: perspective(400px) translateY(0) rotate(0deg) translateZ(0px) translateX(0);
          }
          50% {
            transform: perspective(400px) rotate(-45deg) translateZ(20px) translateY(20px) translateX(20px);
          }
        }
      }
    }
    #lc{
      padding: 100px 0;
      background: #fff;
      .head_title{
        text-align: left;
        >:nth-child(1){
          color: #798490;
          font-size: 0.37rem;
          margin-bottom: 0.37rem;
        }
        >:nth-child(2){
          color: #0C2139;
          font-size: 1.11rem;
          margin-bottom: 1rem;
        }
      }
      .container {
        display: flex;
        align-items: center;
        .left,.right{
          flex: 1;
        }
        .left{
          margin-right: 1rem;
          .reason_content{
            display: flex;
            align-items: center;
            img{
              width: 150px;
              margin-right: 15px;
            }
            div{
              line-height: 20px;
              font-size: 12px;
            }
          }
        }
        .right{
          margin-left: 50px;
          .items{
            background: $index_color;
            margin-bottom: 37px;
            color: #fff;
            font-size:18px;
            padding: 20px 30px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            >:nth-child(1){
              width: 62px;
              height: 62px;
              border-radius: 50%;
              background: #fff;
              color:$index_color;
              margin-right: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
            }
          }
        }
      }
    }
    #dk{
      display: flex;
      align-items: center;
      background: url("../../../assets/images/index/page1.png") no-repeat left top;
      height: 324px;
      background-size: cover;
      position: relative;
      #dk_zz{
        height: 100%;
        width: 100%;
        /*background: #294e7c;*/
        opacity: 0.7;
        position: absolute;
        z-index:1
      }
      .container{
        display: flex;
        align-items: center;
        >:nth-child(1){
          color: #fff;
          flex: 1;
          >:nth-child(1){
            font-size: 0.44rem;
            margin-bottom: 20px;
          }
          >:nth-child(2){
            font-size: 0.89rem;
          }
        }
        >:nth-child(2) {
          flex: 1;
          text-align: right;
        }
      }
    }
    #footer{
      background: url("../../../assets/images/index/footer-bg-1-1.jpg") no-repeat left top;
      height: 12rem;
      background-size: cover;
      padding-top: 1.83rem;
      box-sizing: border-box;
      .container{

        >div{
          display: flex;
          div{
            flex: 1;
            color: #87909A;
            line-height: 36px;
            font-size: 0.3rem;
            h4{
              color: #fff;
              font-weight: 500;
              font-size: 0.33rem;
            }
          }
        }
      }
    }
  }
  .btns{
    background: $color;
    border-color: $color;
  }
  /deep/ .van-slider__button{
    width: 0.32rem!important;
    height: 0.32rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/desk.vue